/** Dashboard widget: which external data-provider API keys are configured. */

import React, { useEffect, useState } from "react";
import { apiClient } from "@/api/client";
import type { ProviderStatus as ProviderStatusType } from "@/types";
import WidgetCard from "./WidgetCard";

const PROVIDERS: Array<{ key: keyof ProviderStatusType; label: string }> = [
  { key: "market_data_configured", label: "Market data" },
  { key: "news_configured", label: "News" },
  { key: "fundamentals_configured", label: "Fundamentals" },
];

export default function ProviderStatusWidget(): React.ReactElement {
  const [status, setStatus] = useState<ProviderStatusType | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    apiClient
      .get<ProviderStatusType>("/system/providers")
      .then(({ data }) => setStatus(data))
      .catch(() => setError("Unable to load provider status"));
  }, []);

  return (
    <WidgetCard title="Provider status" isLoading={status === null && !error} error={error}>
      {status && (
        <ul className="space-y-1.5">
          {PROVIDERS.map(({ key, label }) => (
            <li key={key} className="flex items-center justify-between text-sm">
              <span className="text-mist-200">{label}</span>
              <span className={status[key] ? "text-signal-teal" : "text-mist-400"}>
                {status[key] ? "Configured" : "Not configured"}
              </span>
            </li>
          ))}
        </ul>
      )}
    </WidgetCard>
  );
}
